import { render, staticRenderFns } from "./golongan.vue?vue&type=template&id=7964141a&"
import script from "./golongan.vue?vue&type=script&lang=js&"
export * from "./golongan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports